import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { log } from "console";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";
import { InstallmentConfigService } from "src/app/services/installment-config.service";

@Component({
  selector: "app-secure-installment-config-installment-config-edit-modal",
  templateUrl: "./installment-config-edit-model.component.html",
  styleUrls: ["./installment-config-edit-model.component.scss"],
})
export class InstallmentConfigEditModalComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  installmentConfigurationType: string;
  header: string;
  installmentType: string;
  installmentOrder: number;
  initialPercent: number;
  initialAmount: number;
  initialPayDays: number;
  initialWithIntPayDays: number;
  startDate: string;
  otherInstallmentType: string;
  otherInstallmentOrder: number;

  viewInstallmentType: string;
  viewLottery: number;
  viewschemeKey: number;

  viewInstallmentOrder: number;
  otherInstallmentNames: string[];
  lotteries: { [key: number]: string };
  schemes: { [key: number]: string };
  installmentTypes: { [key: number]: string };
  installmentPercent: number;
  installmentDuePaymentDays: number;
  installmentDuePaymentDaysWithInterest: number;
  lotteryKey: number;
  lotteryInstKey: number;
  installmentAmount: number;
  schemeInstKey: number;

  schemeKey: number;

  lotteryInstallmentConfigs: LotteryInstallmentConfigurationModel[] = [];
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  key: number;
  constructor(
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Inside ngOnInit method
    this.form = new FormGroup({
      // ... other form controls
      intrestChartLst: new FormArray([]),
    });
    // this.lotteryInstKey = this.lotteryInstKey;
    console.log("this.this.schemeKey?.key", this.schemeKey);
    console.log("this.lotteryKey?.key", this.lotteryKey);
    console.log("this.installmentType", this.installmentType);
    this.viewLottery = this.lotteryKey;
    this.viewschemeKey = this.schemeKey;
    if (this.viewschemeKey) {
      this.installmentConfigService
        .viewWithScheme(
          this.viewLottery,
          this.viewschemeKey,
          this.installmentType
        )
        .subscribe((data: any) => {
          // this.isLoading = true;
          if (data.status === "SUCCESS") {
            console.log(
              "Lottery key get for edit ",
              data.lotteryInstallmentConfigs
            );

            this.initialPercent =
              data.schemeInstallmentConfigs[0].installmentPercent;
            this.initialPayDays =
              data.schemeInstallmentConfigs[0].installmentDuePaymentDays;
            this.initialWithIntPayDays =
              data.schemeInstallmentConfigs[0].installmentDuePaymentDaysWithInterest;
            this.lotteryInstKey =
              data.schemeInstallmentConfigs[0].lotteryInstKey;
            this.installmentAmount =
              data.schemeInstallmentConfigs[0].installmentAmount;

            // Assuming data.lotteryInstallmentConfigs[0].intrestChartLst is an array of objects
            const intrestChartArray =
              data.schemeInstallmentConfigs[0].intrestChartLst;

            // Clear existing form array to avoid duplicates
            const intrestChartArrayControl = this.form.get(
              "intrestChartLst"
            ) as FormArray;
            intrestChartArrayControl.clear();

            // Populate the form array with data
            intrestChartArray.forEach((item) => {
              intrestChartArrayControl.push(
                new FormGroup({
                  key: new FormControl(item.key),
                  startDate: new FormControl(
                    item.startDate,
                    Validators.required
                  ),
                  endDate: new FormControl(item.endDate),
                  instPaymentInterestRate: new FormControl(
                    item.instPaymentInterestRate,
                    Validators.required
                  ),
                })
              );
            });
          } else {
          }
        });
    } else {
      this.installmentConfigService
        .viewWithLottery(this.viewLottery, this.installmentType)
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            console.log(
              "Lottery key get for edit ",
              data.lotteryInstallmentConfigs
            );

            this.initialPercent =
              data.lotteryInstallmentConfigs[0].installmentPercent;
            this.initialPayDays =
              data.lotteryInstallmentConfigs[0].installmentDuePaymentDays;
            this.initialWithIntPayDays =
              data.lotteryInstallmentConfigs[0].installmentDuePaymentDaysWithInterest;
            this.lotteryInstKey =
              data.lotteryInstallmentConfigs[0].lotteryInstKey;

            const intrestChartArray =
              data.lotteryInstallmentConfigs[0].intrestChartLst;

            const intrestChartArrayControl = this.form.get(
              "intrestChartLst"
            ) as FormArray;
            intrestChartArrayControl.clear();

            // Populate the form array with data
            intrestChartArray.forEach((item) => {
              intrestChartArrayControl.push(
                new FormGroup({
                  key: new FormControl(item.key),
                  startDate: new FormControl(
                    item.startDate,
                    Validators.required
                  ),
                  endDate: new FormControl(item.endDate),
                  instPaymentInterestRate: new FormControl(
                    item.instPaymentInterestRate,
                    Validators.required
                  ),
                })
              );
            });
          } else {
            //toast data.errorMessage
          }
        });
    }

    this.viewInstallmentType = this.installmentType;
    console.log("modal - otherInstallmentNames-", this.otherInstallmentNames);
    this.form = new FormGroup({
      otherCharges: new FormControl(this.initialPercent === 0),
      instPaymentInterestRate: new FormControl(null, [
        Validators.pattern(/^\d*\.?\d*$/),
        Validators.max(100),
        Validators.min(0),
      ]),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      installmentDuePaymentDays: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      installmentDuePaymentDaysWithInterest: new FormControl(null, [
        Validators.pattern(/^\d+$/),
        Validators.max(400),
        Validators.min(10),
      ]),
      intrestChartLst: new FormArray([]),
    });

    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.push(
      new FormGroup({
        key: new FormControl(null),
        startDate: new FormControl(null, Validators.required),
        endDate: new FormControl(null),
        instPaymentInterestRate: new FormControl(null, Validators.required),
      })
    );

    if (this.initialPercent === 0) {
      this.form.removeControl("installmentPercent");
      this.form.addControl(
        "installmentAmount",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
        ])
      );
      this.form.addControl(
        "otherChargeName",
        new FormControl(null, [Validators.required])
      );
      this.viewInstallmentOrder = this.otherInstallmentOrder;
    } else {
      this.form.removeControl("installmentAmount");
      this.form.removeControl("otherChargeName");
      this.form.addControl(
        "installmentPercent",
        new FormControl(null, [
          Validators.required,
          Validators.pattern(/^\d+$/),
          Validators.max(this.initialPercent),
          Validators.min(1),
        ])
      );
      this.viewInstallmentOrder = this.installmentOrder;
    }

    // this.installmentConfigService
    //   .initWithLotteryEdit(
    //     this.lotteryInstallmentConfigs[0].installmentType,
    //     this.lotteryInstallmentConfigs[0].lotteryKey,
    //     this.lotteryInstallmentConfigs[0].lotteryInstKey
    //   )
    //   .subscribe(
    //     (data) => {
    //       // this.isLoading = false;
    //       if (data.status === "SUCCESS") {
    //         this.schemes = data.schemes;
    //         this.installmentTypes = data.installmentTypes;
    //         this.installmentPercent =
    //           data.lotteryInstallmentConfigs[0].installmentPercent;
    //       } else {
    //         this.installmentConfigService.errorToast(data.errorMessage);
    //       }
    //     },
    //     (error) => {
    //       this.installmentConfigService.errorToast(
    //         error?.error?.message || error?.error?.errorMessage
    //       );
    //       // this.isLoading = false;
    //     }
    //   );
  }

  // onSelectOtherCharges(e: any) {
  //   if (e?.target?.checked === true) {
  //     this.form.removeControl("installmentPercent");
  //     this.form.addControl(
  //       "installmentAmount",
  //       new FormControl(null, [
  //         Validators.required,
  //         Validators.pattern(/^\d+$/),
  //       ])
  //     );
  //     this.form.addControl(
  //       "otherChargeName",
  //       new FormControl(null, [Validators.required])
  //     );
  //     this.viewInstallmentOrder = this.otherInstallmentOrder;
  //   } else {
  //     this.form.removeControl("installmentAmount");
  //     this.form.removeControl("otherChargeName");
  //     this.form.addControl(
  //       "installmentPercent",
  //       new FormControl(null, [
  //         Validators.required,
  //         Validators.pattern(/^\d+$/),
  //         Validators.max(this.initialPercent),
  //         Validators.min(1),
  //       ])
  //     );
  //     this.viewInstallmentOrder = this.installmentOrder;
  //   }
  // }

  onSubmit() {
    if (this.initialWithIntPayDays) {
      if (this.initialPayDays > this.initialWithIntPayDays) {
        this.isSubmitDisabled = false;
        alert(
          "Installment Pay days with interest should be more than or equal to Installment Pay days"
        );
      } else {
        console.log(
          "this.installmentPercentthis.installmentPercentthis.installmentPercent",
          this.installmentPercent
        );
        return this.modalCtrl.dismiss(
          {
            key: this.viewInstallmentOrder,
            otherCharge: this.form.value.otherCharges ? "Y" : "N",
            installmentType: this.form.value.otherCharges
              ? this.form.value.otherChargeName
              : this.viewInstallmentType,
            installmentPercent: this.initialPercent,
            installmentAmount: this.form.value.installmentAmount,
            // instPaymentInterestRate: this.form.value.instPaymentInterestRate,
            installmentDuePaymentDays: this.initialPayDays,
            installmentDuePaymentDaysWithInterest: this.initialWithIntPayDays,
            lotteryInstKey: this.lotteryInstKey,
            schemeInstKey: this.schemeInstKey,

            intrestChartLst: this.form.value.intrestChartLst.map((ur) => ({
              key: ur.key,
              startDate: ur.startDate,
              endDate: ur.endDate,
              instPaymentInterestRate: ur.instPaymentInterestRate,
            })),
          },
          "submit"
        );
      }
    } else {
      return this.modalCtrl.dismiss(
        {
          key: this.viewInstallmentOrder,
          otherCharge: this.form.value.otherCharges ? "Y" : "N",
          installmentType: this.form.value.otherCharges
            ? this.form.value.otherChargeName
            : this.viewInstallmentType,
          installmentPercent: this.form.value.installmentPercent
            ? this.form.value.installmentPercent
            : this.installmentPercent,
          installmentAmount: this.form.value.installmentAmount,
          instPaymentInterestRate: this.form.value.instPaymentInterestRate,
          installmentDuePaymentDays: this.form.value.installmentDuePaymentDays,
          installmentDuePaymentDaysWithInterest:
            this.form.value.installmentDuePaymentDaysWithInterest,
          intrestChartLst: this.form.value.intrestChartLst.map((ur) => ({
            key: ur.key,
            startDate: ur.startDate,
            endDate: ur.endDate,
            instPaymentInterestRate: ur.instPaymentInterestRate,
          })),
        },
        "submit"
      );
    }
  }
  allowOnlyNumbersAndDecimal(event) {
    const key = event.key;
    const regex = /^[0-9.]$/i;
    return regex.test(key);
  }
  onCancel() {
    return this.modalCtrl.dismiss(null, "close");
  }

  addResponsibility() {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;

    if (
      selectedIntrestChartLst.length === 0 ||
      selectedIntrestChartLst
        .at(selectedIntrestChartLst.length - 1)
        ?.get("instPaymentInterestRate").value
    ) {
      if (
        selectedIntrestChartLst.length === 0 ||
        selectedIntrestChartLst
          .at(selectedIntrestChartLst.length - 1)
          ?.get("startDate").value
      ) {
        if (
          selectedIntrestChartLst.length === 0 ||
          selectedIntrestChartLst
            .at(selectedIntrestChartLst.length - 1)
            ?.get("endDate").value
        ) {
          const previousEndDate =
            selectedIntrestChartLst.length > 0
              ? selectedIntrestChartLst
                  .at(selectedIntrestChartLst.length - 1)
                  ?.get("endDate").value
              : null;
          const parsedEndDate =
            previousEndDate !== null ? new Date(previousEndDate) : null;

          const newStartDate =
            parsedEndDate !== null
              ? this.calculateNextDate(parsedEndDate)
              : null;

          selectedIntrestChartLst.push(
            new FormGroup({
              key: new FormControl(null),
              startDate: new FormControl(newStartDate, Validators.required),
              endDate: new FormControl(null),
              instPaymentInterestRate: new FormControl(
                null,
                Validators.required
              ),
            })
          );
        } else {
          this.installmentConfigService.errorToast(
            "End date not selected. Row not added."
          );
        }
      } else {
        this.installmentConfigService.errorToast(
          "Start date not selected. Row not added."
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Interest Rate not selected. Row not added."
      );
    }
  }

  calculateNextDate(previousEndDate: Date): Date {
    if (previousEndDate instanceof Date && !isNaN(previousEndDate as any)) {
      const nextStartDate = new Date(previousEndDate);
      nextStartDate.setDate(previousEndDate.getDate() + 1);

      return nextStartDate;
    } else {
      // Handle the case where previousEndDate is not a valid Date
      return null; // Or handle it according to your logic
    }
  }

  get DetailOfFamilyMembers() {
    return this.form.get("intrestChartLst")["controls"];
  }

  deleteResponsibility(i: number) {
    let selectedIntrestChartLst: FormArray = this.form.get(
      "intrestChartLst"
    ) as FormArray;
    selectedIntrestChartLst.removeAt(i);
  }
}
